import { render, staticRenderFns } from "./ChannelMmpSummaryList.vue?vue&type=template&id=d2d43358&scoped=true"
import script from "./ChannelMmpSummaryList.vue?vue&type=script&lang=js"
export * from "./ChannelMmpSummaryList.vue?vue&type=script&lang=js"
import style0 from "./ChannelMmpSummaryList.vue?vue&type=style&index=0&id=d2d43358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d43358",
  null
  
)

export default component.exports